import { FC, ReactNode } from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import SvgIcon, { SvgIconName } from '~src/shared/SvgIcon';

import { FieldContainer, HoverText, IconContainer, IconFieldWrapper } from './iconField.sc';

interface Props {
  iconName: SvgIconName;
  selected?: boolean;
  iconClick?: () => void;
  hoverTextKey?: string;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
  children: ReactNode;
}

const IconField: FC<Props> = (props) => {
  const { iconName, viewBoxWidth, viewBoxHeight } = props;
  const iconElement = (
    <SvgIcon width={25} name={iconName} viewBoxWidth={viewBoxWidth} viewBoxHeight={viewBoxHeight} />
  );

  const [t] = useTranslation();

  const hoverText = props.hoverTextKey ? (
    <HoverText data-translation={props.hoverTextKey}>{t(props.hoverTextKey)}</HoverText>
  ) : null;

  return (
    <IconFieldWrapper $selected={props.selected}>
      <IconContainer $clickable={!!props.iconClick} onClick={props.iconClick}>
        {hoverText ? (
          <Tooltip placement="bottom" title={hoverText}>
            <div>{iconElement}</div>
          </Tooltip>
        ) : (
          iconElement
        )}
      </IconContainer>
      <FieldContainer>{props.children}</FieldContainer>
    </IconFieldWrapper>
  );
};

export default IconField;
